import { DocumentItem } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolDocument } from "@virtual-brain-lib/types";

interface DocumentRowProps {
	readonly document: MessageToolDocument;
	readonly onDocumentClick?: (doc: MessageToolDocument) => void;
}

export function DocumentRow({ document, onDocumentClick }: DocumentRowProps) {
	return (
		<div className="flex min-w-0 items-center gap-1">
			<DocumentItem
				className="flex-1"
				mimeType={document.mimeType}
				name={document.name}
				onClick={
					onDocumentClick
						? () => {
								onDocumentClick(document);
							}
						: undefined
				}
			/>
		</div>
	);
}
